<template>
    <v-card-text>
      <v-text-field
        v-model="item.login"
        :error-messages="loginErrors"
        :label="$t('administration.user.login')"
        clearable
        prepend-icon="mdi-account-circle"
        required
        @input="$v.item.login.$touch()"
        @blur="$v.item.login.$touch()"
      ></v-text-field>
    </v-card-text>
</template>

<script>
  import has from 'lodash/has';
  import { validationMixin } from 'vuelidate';
  import { required } from 'vuelidate/lib/validators';
  export default {

    name: 'ForgotPasswordForm',
    mixins: [validationMixin],
    props: {
      values: {
        type: Object,
        required: true
      },
      errors: {
        type: Object,
        default: () => {}
      },
      initialValues: {
        type: Object,
        default: () => {}
      }
    },
    data () {
      return {
        login: null,
        password: null,
      }
    },
    computed: {

      // eslint-disable-next-line
      item() {
        return this.initialValues || this.values;
      },

      loginErrors() {
        const errors = [];

        if (!this.$v.item.login.$dirty) return errors;

        has(this.violations, 'login') && errors.push(this.violations.login);

        !this.$v.item.login.required && errors.push(this.$t('global.field_required'));

        return errors;
      },

      violations() {
        return this.errors || {};
      }
    },
    methods: {

    },
    validations: {
      item: {
        login: {
          required,
        },
      }
    }
  }
</script>
